import { apiAuthCaller } from '@services/apiCaller';
import { IRootStore } from '@stores/index';
import { action, observable } from 'mobx';

interface GrafanaPanel {
  id: string;
  title: string;
  description?: string;
}

interface GrafanaCompleteDashboard {
  uid: string;
  title: string;
  url: string;
  panels: GrafanaPanel[];
}

export interface IGrafanaStore {
  dashboards: GrafanaCompleteDashboard[];
  rootStore: IRootStore;
  getDashboards(): void;
}

export class GrafanaDashboardStore implements IGrafanaStore {
  @observable public dashboards: GrafanaCompleteDashboard[] = [];

  @observable public rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
  }

  @action.bound
  public async getDashboards() {
    const { token } = this.rootStore.userStore;
    const { id } = this.rootStore.organizationStore;
    const res = await apiAuthCaller(token, true).get(`/grafana/${id}/dashboards`);

    this.dashboards = res.data.dashboards;
  }
}
